<template>
  <div v-if="state.buildFinished" class="breadcrumb-wrapper">
    <router-link
      v-if="!isConsultant"
      :to="{
        name: 'home',
      }"
      class="breadcrumb-root"
      />
    <div v-if="!isConsultant" class="breadcrumb-separator" />
    <template v-for="route in routesArray" :key="route.name">
      <router-link :to="route" class="breadcrumb-item">{{
        route.meta.title
      }}</router-link>
      <div class="breadcrumb-separator" />
    </template>
    <div class="breadcrumb-item current" v-text="current_item" />
  </div>
</template>

<script setup lang="ts">
import { reactive, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { spaceApi } from "@/api/space.api";
import { useQuery } from "@tanstack/vue-query";
import { useRoles } from "@/queries/user.query";
import { MemberRole } from "@/types/role";

const router = useRouter();
const route = useRoute();
const appStore = useAppStore();

const { data: space, isPending: isSpacePending } = useQuery({
  queryKey: ['spaces', appStore.currentOrganisationId, appStore.currentSpaceId],
  queryFn: () => spaceApi.get(toValue(appStore.currentOrganisationId), toValue(appStore.currentSpaceId)),
  enabled: !!toValue(appStore.currentOrganisationId) && !!toValue(appStore.currentSpaceId),
});

const { data: roles } = useRoles();

const state = reactive({
  buildFinished: false,
});

const isConsultant = computed(() => {
  if (roles.value?.[0]?.role_backward_compatibility_id === MemberRole.CONSULTANT) {
    return true;
  }
  return false;
});

const current_item = computed(() => {
  if (route.meta.customTitle) {
    return space.value.name || route.meta.customTitle.fallback;
  } else {
    return route.meta.title;
  }
});

function buildRoutesTree(route, array) {
  if (route.meta.parent) {
    const currentParams = route.params;
    const parentRoute = router.resolve({
      name: route.meta.parent.name,
      params: currentParams,
    });

    array.unshift(parentRoute);

    buildRoutesTree(parentRoute, array);
  }

  return array;
}

const routesArray = buildRoutesTree(route, []);

onMounted(() => {
  routesArray.forEach((route) => {
    if (route.meta.customTitle) {
      route.meta.title = space?.value?.name || route.meta.customTitle.fallback;
    }
  });

  state.buildFinished = true;
});
</script>
